// src/components/ConfirmModal.jsx
import React from "react";
import { XMarkIcon, ArrowPathIcon } from "@heroicons/react/24/outline";

export default function ConfirmModal({
  isOpen,
  title = "Are you sure?",
  message = "This action cannot be undone.",
  onConfirm,
  onCancel,
  isLoading = false, // <-- this must match
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-primary rounded-lg shadow-lg w-full max-w-sm p-6 space-y-4">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold text-foreground">{title}</h2>
          <button
            onClick={onCancel}
            disabled={isLoading}
            className="p-1 rounded hover:bg-secondaryAccent/20"
          >
            <XMarkIcon className="h-5 w-5 text-secondaryAccent" />
          </button>
        </div>
        <p className="text-foreground">{message}</p>
        <div className="flex justify-end space-x-2">
          <button
            onClick={onCancel}
            disabled={isLoading}
            className={`px-4 py-2 bg-secondaryAccent text-white rounded focus:outline-none focus:ring-2 focus:ring-secondaryAccent ${
              isLoading
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-secondaryAccent/90"
            }`}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className={`inline-flex items-center space-x-2 px-4 py-2 bg-accent text-white rounded focus:outline-none focus:ring-2 focus:ring-red-600 ${
              isLoading ? "bg-red-400 cursor-not-allowed" : "hover:bg-red-700"
            }`}
          >
            {isLoading ? (
              <>
                <ArrowPathIcon className="h-5 w-5 animate-spin" />
                <span>Deleting…</span>
              </>
            ) : (
              <span>Delete</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
